import{FlexLayout}from"@wp/src/components/common/grid";import styled from"@emotion/styled";export const CompactNetWorthItemContainer=styled(FlexLayout)`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;